export const getClientsList = payload => ({
  type: "FETCH_CLIENT_LIST",
  payload
});

export const setClientsListPaginationPage = pageNumber => {
  return {
    type: "SET_CLIENTS_LIST_PAGINATION_PAGE",
    pageNumber
  };
};

export const setClientListPageSize = pageSize => {
  return {
    type: "SET_CLIENTS_LIST_PAGE_SIZE",
    pageSize
  };
};

export const getBudgetYears = payload => {
  return {
    type: "FETCH_BUDGET_YEARS",
    payload
  };
};

export const setBudgetYear = year => {
  return {
    type: "SET_CLIENTS_LIST_BUDGET_YEAR",
    year
  };
};

export const setClientsListFilterTitle = title => {
  return {
    type: "SET_CLIENTS_LIST_FILTER_TITLE",
    title
  };
};

export const saveClientEntitySetting = resp => {
  return {
    type: "SAVE_CLIENT_ENTITY_SETTING",
    payload: resp
  };
};

export const initClientEntitySetting = () => {
  return {
    type: "INIT_CLIENT_ENTITY_SETTING"
  };
};

export const setClientsBudgetState = budgetState => {
  return {
    type: "SET_CLIENT_BUDGET_FILTER_STATE",
    budgetState
  };
};

export const setClientsBudgetWarningState = warning => {
  return {
    type: "SET_CLIENTS_BUDGET_WARNING",
    warning
  };
};

export const setImportClientsBudgetModal = visible => ({
  type: "SET_IMPORT_CLIENTS_BUDGET_MODAL",
  visible
});

export const importClientsBudget = resp => ({
  type: "IMPORT_CLIENTS_BUDGET",
  payload: resp
});

export const setImportedBudgetYear = year => ({
  type: "SET_CLIENTS_BUDGET_IMPORTED_YEAR",
  year
});

export const setImportBudgetAttachment = importAttachment => ({
  type: "SET_IMPORT_CLIENTS_BUDGET_ATTACHMENT",
  importAttachment
});



// WEBPACK FOOTER //
// ./src/actions/actions/client.js